export const PROJECTS = [
  {
    title: "Bike Itaú",
    description:
      "Website da plataforma de aluguel de bicicletas do cliente Bike Itaú.",
    link: "https://bikeitau.com.br/",
    button: "Website",
    img: "bike-itau.png",
    icons: ["typescript.png", "react.png", "next.png"],
  },
  {
    title: "Minichat!",
    description:
      "Projeto pessoal de aplicação para troca de mensagens instantâneas.",
    link: "https://ptortello.github.io/minichat/",
    button: "Website",
    img: "minichat.png",
    icons: ["javascript.png", "react.png", "firebase.png"],
  },
  {
    title: "Log-Aí",
    description: "Website da plataforma de gestão logística do cliente Log-In.",
    link: "https://logai.loginlogistica.com.br/",
    button: "Website",
    img: "log-ai.png",
    icons: ["typescript.png", "react.png", "redux.png"],
  },
  {
    title: "Space Invaders",
    description: "Réplica do jogo de tiro de 1978 com gráfico bidimensional.",
    link: "https://github.com/PTortello/SpaceInv/",
    button: "Repositório",
    img: "invaders.png",
    icons: ["python.png"],
  },
  {
    title: "Connect 4",
    description:
      "Réplica do jogo de estratégia usando Inteligência Artificial.",
    link: "https://github.com/PTortello/Games/tree/master/Connect4/",
    button: "Repositório",
    img: "connect4.png",
    icons: ["python.png"],
  },
  {
    title: "Portfólio",
    description: "Website desenvolvido utilizando o jogo Zelda como tema.",
    link: "https://github.com/PTortello/portfolio/",
    button: "Repositório",
    img: "link-navi.png",
    icons: ["typescript.png", "react.png"],
  },
];
